/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import ConnectionSelector from './ConnectionSelector/index'
import React from 'react'
import SkipConfirmation from './SkipConfirmation/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CheckInAction/AssignConnection/Content/Content",
  isSubmitting,
  onSubmit
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let checkInAppNameValueData = fromData.useDataValue({ viewPath,
context: 'check_in',
path: 'app_name',
})
let checkInIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'check_in',
})
let connectionsSubmitData = fromData.useDataSubmit({ viewPath,
context: 'connections',
})
let connectionsIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'connections',
})
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaModalHeaderTitle
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 data="check_in.app_name"
 text={checkInAppNameValueData}
/>
</div>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Select the correct doctor profile for this patient to complete check-in."
/>
<ConnectionSelector
{...childProps}
  viewPath={`${viewPath}/ConnectionSelector`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'SkipConfirmation/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'SkipConfirmation/Content'))}
 data="check_in"
 disabled={checkInIsSubmittingData}
 text="Cancel"
/>
<TysiaModalFooterAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 type="primary"
 data="connections"
 onClick={connectionsSubmitData}
 disabled={connectionsIsSubmittingData}
 text="Assign connection"
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
<SkipConfirmation
  viewPath={`${viewPath}/SkipConfirmation`}
/>
{children}
</React.Fragment>)
}